import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';


@Component({
    selector: 'app-notification-type-viewer',
    templateUrl: './notification-type-viewer.component.html',
    styleUrls: ['./notification-type-viewer.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: []
})
export class NotificationTypeViewerComponent {
    @Input() stakeholderName: string|null = null
    @Input() notifyStakeholder: boolean = false;
    @Input() isUrgent: boolean = false;
    @Input() notifySender: boolean = false;
    @Input() notifyReceiver: boolean = false;

    constructor() { }

}
